module.exports = __webpack_public_path__ + "static/media/helloCheck.85194a0a.png";